export const config = (attributes, containerEl) => {
	const { panoType, panoImage, panoVideo, autoRotate, rotateSpeed, hideControl, autoPlay, videoMute, videoLoop } = attributes;

	if (panoType === 'video') {
		const videoSource = panoVideo.url || '';
		const panoramaVideo = new PANOLENS.VideoPanorama(videoSource, {
			autoplay: autoPlay,
			loop: videoLoop,
			muted: videoMute
		});

		const panoramaViewer = new PANOLENS.Viewer({
			container: containerEl,
			controlBar: hideControl
		});
		panoramaViewer.add(panoramaVideo);
	} else {
		const imageSource = panoImage.url || [];
		const panorama = new PANOLENS.ImagePanorama(imageSource);
		const viewer = new PANOLENS.Viewer({
			container: containerEl,
			autoRotate,
			autoRotateSpeed: rotateSpeed,
			controlBar: hideControl
		});
		viewer.add(panorama);
	}
}